// assets/frontend/src/js/taxonomy-filters.js
// ───────────────────────────────────────
// Filtrado local (client-side, sin recarga) de los índices de taxonomías:
// predicadores y series. Cada tarjeta expone su nombre en minúsculas en el
// atributo data-name; el input oculta/muestra tarjetas según coincidencia.
//
// Convenios de IDs (deben coincidir con las plantillas):
//   - #preachers-local-filter  →  #preachersGrid  .preacher-filter-item
//   - #series-local-filter     →  #seriesGrid     .serie-filter-item

function initLocalFilter(inputId, gridId, itemSelector, emptyId) {
  const input = document.getElementById(inputId);
  const grid = document.getElementById(gridId);
  if (!input || !grid) return;

  const empty = emptyId ? document.getElementById(emptyId) : null;

  input.addEventListener('input', () => {
    const query = input.value.toLowerCase().trim();
    let visible = 0;

    grid.querySelectorAll(itemSelector).forEach((item) => {
      const name = item.dataset.name ?? '';
      const show = name.includes(query);
      item.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    if (empty) empty.hidden = visible !== 0;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Índice de predicadores.
  initLocalFilter('preachers-local-filter', 'preachersGrid', '.preacher-filter-item', 'preachers-local-empty');

  // Índice de series.
  initLocalFilter('series-local-filter', 'seriesGrid', '.serie-filter-item', 'series-local-empty');
});
